var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourceMultipleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99498 8.67332L1.13026 5.6686L0.280762 6.32932L5.00022 10L9.71968 6.32932L8.86493 5.66335L4.99498 8.67332ZM5.00022 7.34138L8.85969 4.33666L9.71968 3.67069L5.00022 0L0.280762 3.67069L1.13551 4.33666L5.00022 7.34138Z",
    fill: "#64748D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceMultipleFilled);
export default __webpack_public_path__ + "static/media/sourceMultipleFilled.54ea3332cabff174d65c3d68d0ea3126.svg";
export { ForwardRef as ReactComponent };